import clsx from "clsx"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { Layout } from "../../../ui/layout"
import { MenuItems } from "../../../ui/organisms/navbar/dto"
import Button from "../../../ui/molecules/button"
import { useEffect, useState } from "react"
import { MonitoringFaseAvvioList } from "./list"
import { Pagination } from "../../../ui/organisms/pagination"
import { Calendar } from "../../../ui/molecules/calendar"
import { SingleCheckbox } from "../../../ui/molecules/SingleCheckbox"
import { LogoSpinnerComponent } from "../../../lib/spinner/spinnerLogo"
import { GetAllFaseAvvio, setGetAllFaseAvvioEndingDate, setGetAllFaseAvvioFiltersPage, setGetAllFaseAvvioStartingDate } from "./slice"
import { format } from "date-fns"

export function MonitoringFaseAvvio() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const faseAvvio = useAppSelector(state => state.faseAvvio)

    if (faseAvvio.getAllFaseAvvioStatus === 'loading') {
        return (
            <LogoSpinnerComponent fullScreen />
        )
    }


    return (
        <Layout menuItem={MenuItems.GESTIONE_CONTROLLO} breadcrumbItems={['Dashboard', 'Gestione Controllo', 'Monitoraggio Fase di Avvio']}
            noPaddingLat
            headerLabel="Monitoraggio Fase di Avvio"
        >
            <div style={{ padding: '24px' }}>
                <div className="w-[100%] flex flex-col gap-[16px] filter" style={{ padding: '24px 0px 0px 0px' }}>
                    <div className="flex flex-row gap-[16px]" style={{ flex: 1, alignItems: 'center' }}>
                        <div style={{ justifyContent: 'left', flex: 0.7 }} className="flex gap-[16px] items-center">

                            <div style={{ flex: '0.33' }}>
                                <Calendar
                                    label="Data Inizio"
                                    //onClear={(date) => dispatch(setGetAllEPFilterFrom(date))}
                                    selected={faseAvvio.GetAllFaseAvvioFilters.from}
                                    onChange={(date) => dispatch(setGetAllFaseAvvioStartingDate(format(new Date(date), 'yyyy-MM-dd')))}
                                />
                            </div>
                            <div style={{ flex: '0.33' }}>

                                <Calendar
                                    label="Data Finale"
                                    // onClear={(date) => dispatch(setGetAllEPFilterTo(date))}
                                    selected={faseAvvio.GetAllFaseAvvioFilters.to}
                                    onChange={(date) => dispatch(setGetAllFaseAvvioEndingDate(format(new Date(date), 'yyyy-MM-dd')))}
                                />
                            </div>
                            <div style={{ flex: '0.33' }}>

                                <SingleCheckbox
                                    name={'active'}
                                    checked={false}
                                    setChecked={(value) => {
                                        console.log('valore ', value)
                                    }}
                                    label='Nascondi Clienti con certificato emesso'
                                />
                            </div>
                            <div style={{ flex: '0.33', display: 'flex', alignItems: 'center' }}>
                                <span>
                                    <Button
                                        size={"lg"}
                                        iconPosition={"off"}
                                        variant={"outline"}
                                        label="Cerca"
                                        color={"blue"}
                                        onClick={
                                            () => {
                                                dispatch(GetAllFaseAvvio(faseAvvio.GetAllFaseAvvioFilters))
                                            }
                                        }
                                    />
                                </span>
                            </div>
                        </div>
                        {/* <div style={{ display: 'flex', justifyContent: 'right', flex: 0.3 }}>
                            <Pagination
                                numbResults={faseAvvio.GetAllFaseAvvioResponse ? faseAvvio.GetAllFaseAvvioResponse.total : 0}
                                pages={faseAvvio.GetAllFaseAvvioResponse?.totalPage || 1}
                                currentPage={faseAvvio.GetAllFaseAvvioFilters.page ? faseAvvio.GetAllFaseAvvioFilters.page : 0}
                                detailsResults={'clienti'}
                                setPage={
                                    (page) => {
                                        dispatch(setGetAllFaseAvvioFiltersPage(page))
                                        dispatch(GetAllFaseAvvio(faseAvvio.GetAllFaseAvvioFilters))
                                    }
                                }
                            />
                        </div> */}
                    </div>
                </div>
                <MonitoringFaseAvvioList />

            </div>
        </Layout>
    )
}